module.exports = __webpack_public_path__ + "img/avatar-maxce.569545e8.png";